import React, {Component} from 'react';
import {Buffer} from "buffer";
import MainLayout from "../../components/layouts/MainLayout";
import {withRouter} from "../../hoc/withRouter";
import {AddOrderPolicyStates} from "./types/AddOrderPolicyTypes";
import {orderPolicyService} from "../../services/otodisApi/OrderPolicyService";
import withAuth from "../../hoc/withAuth";
import {Button, Col, Modal} from "antd";
import {LeftOutlined, SaveOutlined} from "@ant-design/icons";
import {HotTable} from '@handsontable/react';
import './AddShippingCost.css';
import Cookies from "universal-cookie";

export interface AddOrderPolicyProps {
}

class AddOrderPolicy extends Component<AddOrderPolicyProps & any, AddOrderPolicyStates> {
    private readonly initState!: AddOrderPolicyStates;
    private readonly id: string;
    private readonly hotSettings: any;
    private readonly hotTableComponent: React.RefObject<any>;
    private user = JSON.parse(Buffer.from(new Cookies().get("_u"), "base64").toString());
    private uDealer = JSON.parse(Buffer.from(new Cookies().get('_d'), "base64").toString());

    constructor(props: AddOrderPolicyProps & any | any) {
        super(props);
        const finalDealerCode = props.match.params.dealerCode.replace(/-/g, '#');
        const picked = this.uDealer.find((o: { DealerCode: any; }) => o.DealerCode === finalDealerCode);
        const companyCode = picked?.DealerCompany ?? "AMARTA";

        this.initState = {
            processing: false,
            processingFetchTableData: true,
            dealerCode: props.match.params.dealerCode.replace(/-/g, '#'),
            dataConfig: [],
            pageSize: 500,
            modalAddWarehouse: false,
            addProcessing: false,
            companyCode: companyCode
        }
        this.state = {...this.initState}

        this.id = 'hot';
        this.hotSettings = {
            data: [['', '', '', '', '', ''], ['', '', '', '', '', '']],
            colHeaders: ['Model', 'Cash Type', 'Cash Book Fee', 'Credit Type', 'Credit Book Fee', 'Kode Inden'],
            width: '100%',
            colWidths: 120
        };
        this.hotTableComponent = React.createRef();
    }

    onDealerChange = async (data: any) => {
        await this.promisedSetState({processingFetchTableData: true, dealerCode: data.value});
    }

    onSubmit = async () => {
        const dataTable = this.hotTableComponent.current.hotInstance.getData();
        const product: any = [];

        for (const item of dataTable) {
            if (item[0]) {
                product.push({
                    vehicle_model: item[0]?.trim()?.toLowerCase()?.replace(/,/g, ''),
                    cash_type: item[1]?.trim()?.toLowerCase()?.replace(/,/g, ''),
                    cash_book_fee: (item[2]) ? parseInt(item[2]?.replace(/,/g, '').replace(/,/g, '/')) : 0,
                    credit_type: item[3]?.trim()?.toLowerCase()?.replace(/,/g, ''),
                    credit_book_fee: (item[4]) ? parseInt(item[4]?.replace(/,/g, '').replace(/,/g, '/')) : 0,
                    indent_code: (item[5]?.toUpperCase() === 'TRUE'),
                });
            }
        }

        const input = {
            company: this.state.companyCode,
            admin_id: "admin",
            data: product
        }

        await this.promisedSetState({processing: true});
        try {
            await orderPolicyService.createUpdateData(
                input
            ).then(() => {
                Modal.success({title: 'Proses Sukses', content: 'Data berhasil diupdate'});
                setTimeout(function () {
                    window.location.reload();
                }, 2000);
            });
        } catch (e) {
            Modal.error({title: 'Proses Gagal', content: 'Server Menolak Inputan Anda :' + e});
            await this.promisedSetState({processing: false});
        }

        if (product?.length === 0) {
            Modal.error({title: 'Proses Gagal', content: 'Data tidak lengkap'});
            await this.promisedSetState({processing: false});
            return;
        }

        await this.promisedSetState({processing: true});
    }

    promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

    render() {
        return (
            <React.Fragment>
                <MainLayout noPadNoMar={true} onChangeDealer={this.onDealerChange} breadcrumbPath={`Setting`} breadcrumbMenu={`Add / Update Kebijakan Order`} defaultSelectedKeys={['m-setting-order-policy']} defaultOpenKeys={['sm-setting']}>
                    <Col style={{float: "right"}} span={24} className={`pad-10`}>
                        <a href={`/${this.state.dealerCode.replace(/#/g, '-')}/order-policy`}>
                            <Button icon={<LeftOutlined/>}>Cancel</Button>
                        </a>
                    </Col><br/><br/>
                    <Col span={24} className={`pad-10`}>
                        <Button type={'primary'} icon={<SaveOutlined/>} loading={this.state.processing} onClick={this.onSubmit}>Update Data
                        </Button> <br/><br/>
                        <div>
                            <HotTable ref={this.hotTableComponent} id={this.id} settings={this.hotSettings}/>
                        </div>
                        <br/>
                        <div style={{fontSize: "80%"}}>
                            Contoh Format: <br/> <a target={`_blank`} href={`https://docs.google.com/spreadsheets/d/1h1F2xZSrL4gD78FPEZwAMuz7o9j6wPuuweJGrNY-quc/edit?usp=sharing`}>https://docs.google.com/spreadsheets/d/1h1F2xZSrL4gD78FPEZwAMuz7o9j6wPuuweJGrNY-quc/edit?usp=sharing</a>
                        </div>
                    </Col>
                </MainLayout>
            </React.Fragment>
        );
    }
}

export default (withAuth(withRouter(AddOrderPolicy), 27));
